import React, { useState, useEffect, useContext } from 'react';
import { Fab, Tooltip } from "@mui/material"
import axios from 'axios'
import NorthWestIcon from '@mui/icons-material/NorthWest';
import { ClearMapListeners, RedrawMap } from '../../../utils/MapUtils';
import { MapContext } from '../../../store/context';

import {
    RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue,
    useSetRecoilState
} from 'recoil';
var polyline = require('@mapbox/polyline');

export default function SelectBlocks(props) {

    const ctx = useContext(MapContext)
    const [active, setActive] = useState(false)
    const mapSettings = ctx.settings
    const map = ctx.map
    const [color, setColor] = useState('primary')

    useEffect(() => {
        if (map && active) {
            var feats = {
                'type': 'FeatureCollection',
                'features': mapSettings.selectedBlocks
            };
            map.getSource('blocks-to-cut').setData(feats)
        }
    }, [mapSettings.selectedBlocks, active])

    useEffect(() => {
        if (active) {
            setColor('secondary')
            mapSettings.setMode('select-block')
        } else {
            setColor('primary')
            ClearMapListeners(map)
        }
    }, [active])

    useEffect(() => {
        if (mapSettings.mode !== 'select-block') {
            setActive(false)
        } else if (mapSettings.mode === 'select-block') {
            setActive(true)
        }
    }, [mapSettings.mode])

    useEffect(() => {
        if (active) {
            map.on('click', 'plan-layer', (e) => {
                console.log('block clicked, active')
                mapSettings.setSelectedBlocks(val => [...val, { type: 'Feature', geometry: e.features[0].geometry }])
                mapSettings.setSelectedBlockIDs(val => [...val, e.features[0].properties.blockgeo_id])
            })
        }
    }, [active, mapSettings.mode])

    function handleClick() {
        setActive(val => !val)
    }

    return (
        <Tooltip title='Select blocks.' placement="left">
            <Fab size="medium" color={color} onClick={() => {
                handleClick()
            }}>
                <NorthWestIcon color="#000" />
            </Fab>
        </Tooltip>
    )
}